// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"839":"2f100182","920":"fddc3d30","939":"fddc3d30"}[chunkId] + ".chunk.css";
};